import { useCallback, useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { sendChatInviteLink } from "controllers/matchingDetails";

const INVITE_STATUS = {
  alreadySent: "Invite already Sent!",
  firstSent: "Invite sent!",
};

const useResendChatInvite = () => {
  const [inviteSentStatus, setInviteSentStatus] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [chatInviteLink, setChatInviteLink] = useState();
  const [linkCopied, setLinkCopied] = useState(false);
  const [apiError, setApiError] = useState(false);

  const copyLinkTimeoutRef = useRef();

  const { jobTalentId } = useParams();
  const localeStorageJobTalentIdKey = `InviteSentStatus-${jobTalentId}`;

  const loadInviteStatusFromLocalStorage = () => {
    const inviteStatusForCurrentTalentId = localStorage.getItem(
      localeStorageJobTalentIdKey
    );
    if (!inviteStatusForCurrentTalentId) {
      return;
    }
    setInviteSentStatus(INVITE_STATUS.alreadySent);
  };

  const sentNewInvite = useCallback(async () => {
    setIsLoading(true);
    setApiError(false);
    try {
      const data = await sendChatInviteLink({
        job_talent_infoid: jobTalentId,
      });
      if (!data) {
        throw new Error("Api failed to send chat invite link");
      }
      const { response } = data;
      if (response) {
        localStorage.setItem(localeStorageJobTalentIdKey, true);
        setInviteSentStatus(INVITE_STATUS.firstSent);
      }
      // TODO - this is not sent from BE yet
      if (response.inviteLink) {
        setChatInviteLink(response.inviteLink);
      }
    } catch (err) {
      setApiError(true);
      setInviteSentStatus(undefined);
    } finally {
      setIsLoading(false);
    }
  }, [jobTalentId]);

  const copyLinkToClipboard = useCallback(async () => {
    await navigator.clipboard.writeText(chatInviteLink);
    setLinkCopied(true);
    copyLinkTimeoutRef.current = setTimeout(() => {
      setLinkCopied(false);
    }, 3000);
  }, [chatInviteLink]);

  useEffect(() => {
    loadInviteStatusFromLocalStorage();

    return () => {
      copyLinkTimeoutRef.current && clearTimeout(copyLinkTimeoutRef.current);
    };
  }, []);

  return {
    inviteSentStatus,
    isLoading,
    chatInviteLink,
    linkCopied,
    apiError,
    sentNewInvite,
    copyLinkToClipboard,
  };
};

export default useResendChatInvite;
